export const ARTIFACT_ID = 'com.wixpress.growth-garage.gg-business-starter-app';
export const SENTRY_DSN = 'https://7a7d14bcaaa14e01bd28b7cf066b002b@sentry-next.wixpress.com/17591';
